var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import FilledError from 'acud-icon/lib/icons/FilledError';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import FilledSuccess from 'acud-icon/lib/icons/FilledSuccess';
import FilledWarn from 'acud-icon/lib/icons/FilledWarn';
import FilledInfo from 'acud-icon/lib/icons/FilledInfo';
import classNames from 'classnames';
import ConfigProvider, { ConfigContext, globalConfig } from '../config-provider';
import Button from '../button';
import Modal from './Modal';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import { getModalLocale } from './locale';
const DialogType = {
    success: { className: 'sucess', icon: <FilledSuccess color='@S6'/> },
    warning: { className: 'warning', icon: <FilledWarn color='@W6'/> },
    confirm: { className: 'confirm', icon: <FilledWarn color='@W6'/> },
    info: { className: 'info', icon: <FilledInfo color='@B6'/> },
    error: { className: 'error', icon: <FilledError color='@E6'/> }
};
const DialogBox = props => {
    const { className, title, content, closeIcon, cancelBtn, okText, confirmLoading, onOk, onClose, icon, getContainer, prefixCls: propsPrefixCls } = props, restProps = __rest(props, ["className", "title", "content", "closeIcon", "cancelBtn", "okText", "confirmLoading", "onOk", "onClose", "icon", "getContainer", "prefixCls"]);
    const visible = props.visible === undefined ? true : props.visible;
    const type = props.type === undefined ? 'info' : props.type;
    const { getPopupContainer } = React.useContext(ConfigContext);
    const { getPrefixCls } = globalConfig();
    const rootPrefixCls = getPrefixCls('', '');
    const prefixCls = getPrefixCls('modal-dialogbox', propsPrefixCls);
    const [loading, toggleLoading] = React.useState(false);
    const locale = useLocaleReceiver('Modal', getModalLocale());
    const okBtnLoading = React.useMemo(() => {
        if (typeof confirmLoading === 'boolean') {
            return confirmLoading;
        }
        return loading;
    }, [confirmLoading, loading]);
    const handleOk = React.useCallback((e) => {
        const okResult = onOk === null || onOk === void 0 ? void 0 : onOk(e);
        if (okResult && typeof okResult.then === 'function') {
            toggleLoading(true);
            okResult.then((...args) => {
                toggleLoading(false);
                onClose === null || onClose === void 0 ? void 0 : onClose(...args);
            }, (e) => {
                console.error(e);
                toggleLoading(false);
            });
        }
        else {
            onClose === null || onClose === void 0 ? void 0 : onClose(e);
        }
    }, [onOk, onClose]);
    const handleCancel = React.useCallback(() => {
        onClose === null || onClose === void 0 ? void 0 : onClose({ triggerCancel: true });
    }, [onClose]);
    const titleNode = React.useMemo(() => (<>
                <div className={`${prefixCls}-icon`}>
                    {icon || DialogType[type].icon}
                </div>
                <div className={`${prefixCls}-title`}>
                    {title}
                </div>
            </>), [prefixCls]);
    const footer = React.useMemo(() => {
        if (!cancelBtn) {
            let ok = okText;
            if (!ok) {
                switch (type) {
                    case 'confirm':
                        break;
                    case 'success':
                    case 'warning':
                        ok = locale[0].funcCloseText;
                        break;
                    case 'error':
                        ok = locale[0].funcRetryText;
                        break;
                    default:
                        ok = locale[0].okText;
                        break;
                }
            }
            return (<Button prefix={`${rootPrefixCls}-btn`} type="primary" loading={okBtnLoading} onClick={handleOk}>
                        {ok}
                    </Button>);
        }
    }, [okText, cancelBtn, okBtnLoading, handleOk, type, locale]);
    const dialogCloseIcon = React.useMemo(() => (<span className={`${prefixCls}-close-x`}>
                {closeIcon === undefined ? <OutlinedClose className={`${prefixCls}-close-icon`}/> : closeIcon}
            </span>), [prefixCls, closeIcon]);
    return (<ConfigProvider prefixCls={rootPrefixCls}>
            <Modal {...restProps} confirmLoading={okBtnLoading} footer={footer} title={titleNode} className={classNames(className, `${prefixCls}`, `${prefixCls}-${type}`)} getContainer={(getContainer || getPopupContainer)} visible={visible} closeIcon={dialogCloseIcon} onCancel={handleCancel} onOk={handleOk} okText={okText}>
                <div className={`${prefixCls}-content`}>{content}</div>
            </Modal>
        </ConfigProvider>);
};
/*
DialogBox.defaultProps = {
    visible: true,
    type: 'info'
};
*/
export default DialogBox;
